export const CATEGORY_ICON = {
  investments: "icon-columns",
  portfolios: "icon-fund",
  firms: "icon-fund",
  engagements: "icon-fund",
  notes: "icon-note-preview",
  documents: "icon-docs",
  people: "icon-team",
  company: "icon-fund",
};
